
import BtnReadmore from '~/components/common/btn-readmore.vue'
export default {
  components: {
    BtnReadmore
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visibleCount: 4,
      itemsPerLoad: 4,
      currentSlide: 1,
      activeIndex: 0
    }
  },
  computed: {
    displayedarticles() {
      return this.articles
      // return this.articles.slice(0, this.visibleCount)
    },
    totalSlides() {
      return this.articles.length
    }
  },
  mounted() {
    const swiperEl = this.$refs.swiper
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.on('slideChange', () => {
        this.activeIndex = swiperEl.swiper.activeIndex
        this.currentSlide = this.activeIndex + 1
      })
    }
  },
  methods: {
    isYouTubeUrl(url) {
      if (!url) {
        return false
      }
      try {
        const u = new URL(url)
        const host = u.hostname.toLowerCase()
        return host.includes('youtube.com') || host.includes('youtu.be')
      } catch (e) {
        return /youtube\.com|youtu\.be/i.test(url)
      }
    },
    slidePrev() {
      const swiperEl = document.querySelector('swiper-container')
      swiperEl.swiper.slidePrev()

      this.activeIndex = swiperEl.swiper.activeIndex
      this.currentSlide = this.activeIndex + 1
    },
    slideNext() {
      const swiperEl = document.querySelector('swiper-container')
      swiperEl.swiper.slideNext()

      this.activeIndex = swiperEl.swiper.activeIndex
      this.currentSlide = this.activeIndex + 1
    }
  }
}
